export enum AlignmentEnum {
    LEFT = "LEFT",
    CENTER = "CENTER",
    RIGHT = "RIGHT",
    SPACE_BETWEEN = "SPACE_BETWEEN"
}
